import { AUTH_MODE as RUNTIME_AUTH_MODE } from "./runtimeConfig";

/** @type {"legacy" | "keycloak"} */
export const AUTH_MODE = (RUNTIME_AUTH_MODE || "legacy").toLowerCase() === "legacy" ? "legacy" : "keycloak";

export const isLegacyAuth = () => AUTH_MODE === "legacy";

export const isKeycloakAuth = () => AUTH_MODE === "keycloak";
